import React from 'react'
import { Button,Col, ModalBody, ModalFooter, Row } from 'reactstrap';
import './StyleProfile.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export const ViewListprofileCommercial = (props) => {

    const {
           toggle3, listCommercial
        } = props;
           console.log("🚀 ~ ViewListprofileCommercial ~ listCommercial:", listCommercial)
      
    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "6px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",
    };

    const priceBodyTemplate = (rowData) => {
        return `$ ${rowData.price.toFixed(2)}`;
    };

        ////console.log(listCommercial);
  return ( 
            <>
            <div >
           
                {listCommercial.length === 0 ? (
                    <div>
                        <label>No se cuenta con ningún precio asignado</label>
                    </div>
                ) : (
                    <DataTable
                        value={listCommercial}
                        paginator={false}
                        rows={10}
                        className="p-datatable-striped p-datatable-sm"
                        responsiveLayout="scroll"
                        rowsPerPageOptions={[10, 20]}
                    >
                        <Column field="rate_name" header="Tarifario" headerStyle={headerStyle} style={cellStyle} />
                        <Column field="price" header="Precio" body={priceBodyTemplate} headerStyle={headerStyle} style={cellStyle} />
                    </DataTable>
                )}
            
            </div>
            <ModalFooter>
            <Button size="sm" className="btn-air-light" outline color='danger' type="button" onClick={toggle3}>{"Cerrar"}</Button>
            </ModalFooter>
            
            </>
   
  )
}
